import { render, staticRenderFns } from "./addTemplete.vue?vue&type=template&id=0d216afa&scoped=true&"
import script from "./addTemplete.vue?vue&type=script&lang=js&"
export * from "./addTemplete.vue?vue&type=script&lang=js&"
import style0 from "./addTemplete.vue?vue&type=style&index=0&id=0d216afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d216afa",
  null
  
)

export default component.exports